import type { Edge, Node } from "@xyflow/react";
import dagre from "dagre";

const NODE_WIDTH = 240;
const NODE_HEIGHT = 130;
const AGGREGATE_HEIGHT = 160;

interface LayoutOptions {
  rankdir?: "LR" | "TB";
}

export function layoutGraph<T extends Node>(
  nodes: T[],
  edges: Edge[],
  options?: LayoutOptions,
): T[] {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: options?.rankdir ?? "LR", nodesep: 40, ranksep: 90 });

  for (const node of nodes) {
    const height =
      node.data && (node.data as { aggregate?: unknown }).aggregate
        ? AGGREGATE_HEIGHT
        : NODE_HEIGHT;
    g.setNode(node.id, { width: NODE_WIDTH, height });
  }
  for (const edge of edges) {
    g.setEdge(edge.source, edge.target);
  }

  dagre.layout(g);

  return nodes.map((node) => {
    const { x, y } = g.node(node.id);
    return {
      ...node,
      position: { x: x - NODE_WIDTH / 2, y: y - NODE_HEIGHT / 2 },
    };
  });
}
